<template>
  <div>
    <el-select
        v-model="countryCode"
        v-loading="loading"
        :disabled="disabled"
        style="width: 100%"
        clearable
        filterable
        placeholder="Country"
        name="country">
      <el-option
          v-for="(country, _sname) in countryMap"
          :key="_sname"
          :value="_sname"
          :label="country.name">
        <span style="float: left;">{{ country.name }}</span>
        <span style="float: right; color: #999;">{{ _sname | uppercase }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { isNil, trim } from "lodash";

const { mapGetters: sharedGetters, mapActions: sharedActions } =
  createNamespacedHelpers("shared");

import { createNamespacedHelpers } from "vuex";

let normalize = (v) => trim(isNil(v) ? "" : v);

export default {
  name: "CountryInput",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      validator(val) {
        return val === null || typeof val === "string";
      },
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...sharedGetters(["countries"]),
    countryCode: {
      get() {
        return normalize(this.value).toUpperCase();
      },
      set(code) {
        this.$emit("input", code);
      },
    },
    countryMap() {
      return this.countries || [];
    },
  },
  created() {
    this.loadCountries();
  },
  methods: {
    ...sharedActions(["fetchCountries"]),
    loadCountries() {
      this.loading = true;
      this.fetchCountries()
        .catch((_) => {
          this.$notify.error({
            title: "Countries",
            message: "Couldn't be loaded. reload the page",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
